import Personagens from './Personagens/Personagens'
import './App.scss';

function App() {
  return (
    <div className="App">
      <Personagens />
    </div>
  );
}

export default App;
